import * as actionTypes from '../constants/actionTypes';
import SystemApi from '../api/system/systemApi';

export function warmup() {
  return dispatch => {
    dispatch({type: actionTypes.SYSTEM_WARMUP_API});
    return SystemApi.warmup();
  };
}



// WEBPACK FOOTER //
// ./src/actions/systemActions.js